import React from 'react'
import Button, { TYPES as BUTTON_TYPES } from '../../../../Button/index'
import Close from '../../../../Icon/icons/Close/index'
import TopicIcon from './TopicIcon'

export interface CommunityProfileTopicTagProps {
  label: string
  selected?: boolean
  editable?: boolean
  disabled?: boolean
  onRemove?: (() => void) | null
  onClick?: ((e: React.MouseEvent | React.KeyboardEvent) => void) | null
  href?: string | null
  icon?: string | null
}

function CommunityProfileTopicTag ({
  label,
  selected = false,
  editable = false,
  disabled = false,
  onRemove = null,
  onClick = null,
  href = null,
  icon = null,
}: CommunityProfileTopicTagProps) {
  const baseClass = 'community-profile-topic-tag'
  const isClickable = !disabled && !!(onClick || href)
  const classes = [
    baseClass,
    selected ? `${baseClass}--selected` : '',
    editable ? `${baseClass}--editable` : '',
    isClickable ? `${baseClass}--clickable` : '',
    disabled ? `${baseClass}--disabled` : '',
  ].filter(Boolean).join(' ')

  const handleKeyDown = isClickable ? (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      if (onClick) onClick(e)
    }
  } : undefined

  const handleClick = (!disabled && onClick) ? onClick : undefined

  if (href && !editable && !onClick && !disabled) {
    return (
      <a
        className={classes}
        href={href}
      >
        {icon ? <span className={`${baseClass}__icon`}><TopicIcon type={icon} /></span> : null}
        <span className={`${baseClass}__label`}>{label}</span>
      </a>
    )
  }

  return (
    <span
      className={classes}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      {icon ? <span className={`${baseClass}__icon`}><TopicIcon type={icon} /></span> : null}
      <span className={`${baseClass}__label`}>{label}</span>
      {editable && onRemove ? (
        <Button
          type={BUTTON_TYPES.GHOST}
          className={`${baseClass}__remove`}
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
          aria-label={`Remove ${label}`}
        >
          <Close />
        </Button>
      ) : null}
    </span>
  )
}

export default React.memo(CommunityProfileTopicTag)
